import React from "react";

import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, Tooltip, Typography } from "@material-ui/core";

import { colors } from "constants/theme";
import { IN_SALE } from "constants/businesses";
import { RegistrationFields } from "lib/businessRegistrations";
import { pluralize } from "lib/pluralize";

export const RenderBusinessOptionWithDetail = (
  option: Omit<Business, "properties"> &
    RegistrationFields & {
      isHeading: boolean;
      isSectionHeading?: boolean;
      properties: { PIC: string }[];
    },
) =>
  option.isSectionHeading ? (
    // data-section-heading lets the listbox undim this disabled option.
    <Box
      data-section-heading
      width="100%"
      paddingTop={1}
      style={{ borderTop: `1px solid ${colors.gray78}` }}
    >
      <Typography variant="subtitle2" style={{ color: colors.gray40 }}>
        {option.label}
      </Typography>
    </Box>
  ) : (
    <Grid component="div" container spacing={2}>
      <Grid item xs={option.id || option.isHeading ? 3 : 12}>
        <Typography noWrap>
          {option.isHeading ? "Business" : option.label}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        {option.isHeading ? "ABN" : option.abn || ""}
      </Grid>
      <Grid item xs={4}>
        <Tooltip
          title={`Business has ${option.properties?.length} ${pluralize("Property", option.properties?.length)}`}
        >
          <Typography noWrap>
            {option.isHeading
              ? "PICs"
              : option.properties?.map(p => p.PIC).join(", ") || ""}
          </Typography>
        </Tooltip>
      </Grid>
      <Grid item xs={3}>
        <Typography noWrap>
          {option.isHeading
            ? "Primary Email"
            : option.primaryContactEmail || ""}
        </Typography>
      </Grid>
    </Grid>
  );

export const InSaleRenderOption = option => {
  if (option[IN_SALE]) {
    // Highlight if they are in the sale already
    return (
      <Box justifyContent="space-between" display="flex" width="100%">
        {option.label}
        <FontAwesomeIcon icon={faCircle} color={colors.activeColor} />
      </Box>
    );
  }
  return option.label;
};
